import { render, staticRenderFns } from "./taskClaimSetting.vue?vue&type=template&id=7f72ca78&scoped=true&"
import script from "./taskClaimSetting.vue?vue&type=script&lang=js&"
export * from "./taskClaimSetting.vue?vue&type=script&lang=js&"
import style0 from "./taskClaimSetting.vue?vue&type=style&index=0&id=7f72ca78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72ca78",
  null
  
)

export default component.exports